import request from '@/api/request'

export default {
  async getAccounts (options) {
    return (await request.get(`module/action/marketplace/shein/account/index`, {
      params: options
    })).data
  },

  async getAccountByIdentifier (identifier) {
    return (await request.get(`module/action/marketplace/shein/account/getOneById/${identifier}`)).data
  },

  async authenticate (code) {
    return (await request.get(`module/action/marketplace/shein/account/authenticate/${code}`)).data
  },

  async refreshTokenManually (identifier) {
    return (await request.get(`module/action/marketplace/shein/account/refreshTokenManually/${identifier}`)).data
  },

  async updateAccountStatus (identifier, status) {
    if (status) {
      return (await request.get(`module/action/marketplace/shein/account/activate/${identifier}`)).data
    }
    return (await request.get(`module/action/marketplace/shein/account/deactivate/${identifier}`)).data
  },

  async getCategories (accountIdentifier) {
    return (await request.get(`module/action/marketplace/shein/category/retrieve`, {
      headers: { 'Shein-Account': accountIdentifier }
    })).data
  },

  async getBrands (accountIdentifier, productTypeId) {
    return (await request.get(`module/action/marketplace/shein/brand/retrieve/${productTypeId}`, {
      headers: { 'Shein-Account': accountIdentifier }
    })).data
  },

  async getAttributes (accountIdentifier, productTypeId) {
    return (await request.get(`module/action/marketplace/shein/attributes/retrieve/${productTypeId}`, {
      headers: { 'Shein-Account': accountIdentifier }
    })).data
  },

  async syncOrder (type, identifier, code, account) {
    return (await request.get(`module/action/${type}/${identifier}/order/sync/${code}`, {
      headers: { 'Shein-Account': account }
    })).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/shein/index.js